import { _ as _isFunction } from './_Map-9acd9da3.js';
import { _ as _reduce } from './reduce-359d9da9.js';

/**
 * Chain function calls until one return a "valid" result
 *
 * A valid result is a result for which the validity function return true for
 *
 * If no function return a valid result, null is returned, the last function can be used to return a default value
 */
var chain = function chain(validity) {
  if (!_isFunction(validity)) {
    throw new Error('Validity function isnt a callable function');
  }

  for (var _len = arguments.length, callsToChain = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    callsToChain[_key - 1] = arguments[_key];
  }

  return _reduce(callsToChain, function (prev, callToChain) {
    if (validity(prev)) {
      return prev;
    }

    if (callToChain && _isFunction(callToChain)) {
      return callToChain();
    }

    return null;
  }, null);
};

export { chain as c };
